import { Link } from "react-router-dom";

export default function ArticleSocialBlock({ className = "" }) {
  return (
    <div className={`soft-card overflow-hidden p-5 sm:p-6 ${className}`}>
      <div>
        <h3 className="text-sm font-black uppercase tracking-[0.18em] text-neutral-500">
          Continue reading
        </h3>
        <p className="mt-2 text-sm leading-6 text-neutral-600">
          Open the latest robotics reporting, Physical AI analysis and hardware notes.
        </p>
      </div>

      <Link to="/robotics-news" className="btn-secondary mt-5 px-4 py-2">
        Browse robotics news
      </Link>
    </div>
  );
}
